
import { Empty, Layout } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import {
  HeaderComponent,
  SectionTabs,
} from "@comps/components";
import { checkPermissions } from '@comps/commonFunctions';
import IndexUsers from './components/users/IndexUsers';
import IndexRoles from './components/roles/IndexRoles';
import IndexLogs from './components/logs/IndexLogs';
import IndexMachineTypes from './components/machineTypes/IndexMachineTypes';
import IndexRequestFlows from './components/requestFlow/IndexRequestFlow';
import IndexMachines from './components/machines/IndexMachine';
import IndexScheduler from './components/schedulers/IndexScheduler';
import IndexAdmsMachines from './components/admsMachines/IndexAdmsMachines';

const { Content } = Layout;
const SYSTEM_MASTER_TAB_KEY = "systemMasterActiveTab";
const DEFAULT_SYSTEM_MASTER_TAB = "roles";

const IndexSystemMasters = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  //------------use states start----------------
  const [currentTab, setCurrentTab] = useState(() => localStorage.getItem(SYSTEM_MASTER_TAB_KEY) || DEFAULT_SYSTEM_MASTER_TAB);
  //-----------end use states--------------------
  const onChangeTab = (e) => {
    localStorage.setItem('filterPath', `/masters/system?tab=${e}`)
    localStorage.setItem(SYSTEM_MASTER_TAB_KEY, e)
    setSearchParams({ tab: e });
    setCurrentTab(e)
  };
  const tabs = useMemo(() => [
    { tab: "Roles", key: "roles", modkey: "roles", content: <IndexRoles modkey="roles" /> },
    { tab: "Machines", key: "machines", modkey: "machines", content: <IndexMachines modkey="machines" /> },
    { tab: "ADMS Machines", key: "admsMachines", modkey: "machines", content: <IndexAdmsMachines modkey="machines" /> },
    { tab: "Machine Types", key: "machineType", modkey: "machineType", content: <IndexMachineTypes modkey="machineType" /> },
    { tab: "Request Flow", key: "requestFlow", modkey: "requestFlow", content: <IndexRequestFlows modkey="requestFlow" /> },
    { tab: "Users", key: "users", modkey: "users", content: <IndexUsers modkey="users" /> },

    { tab: "Activity Logs", key: "logs", modkey: "logs", content: <IndexLogs modkey="logs" /> },
  ], []);
  const allowedTabs = tabs.filter((tab) => checkPermissions(tab.modkey));

  useEffect(() => {
    const requestedTab = searchParams.get('tab');
    if (requestedTab && allowedTabs.some((tab) => tab.key === requestedTab)) {
      localStorage.setItem(SYSTEM_MASTER_TAB_KEY, requestedTab);
      setCurrentTab(requestedTab);
    }
  }, [allowedTabs, searchParams]);

  useEffect(() => {
    if (allowedTabs.length && !allowedTabs.some((tab) => tab.key === currentTab)) {
      localStorage.setItem(SYSTEM_MASTER_TAB_KEY, allowedTabs[0].key);
      setCurrentTab(allowedTabs[0].key);
    }
  }, [allowedTabs, currentTab]);
  //-----------styling------------

  const TabContentStyle = { background: 'white', padding: '10px 20px 20px' }
  // No title/breadcrumb: the workspace nav and the tab bar below already say
  // where you are, so a header here was redundant and only ate vertical space.
  const pageConfig = {
    headers: {
      title: "",
    },
  };
  //----------end styling-----------
  return (
    <>
      <Layout>
        <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>

        </HeaderComponent>
        <Layout hasSider>
          <Content style={ TabContentStyle }>
            { allowedTabs.length ? (
              <SectionTabs
                activeKey={ currentTab }
                onChange={ onChangeTab }
                items={ allowedTabs.map((tab) => ({
                  key: tab.key,
                  label: tab.tab,
                  children: tab.content,
                })) }
              />
            ) : <Empty description="No system master tabs are available for your role." /> }
          </Content>

        </Layout>
      </Layout>
    </>
  );

};
export default IndexSystemMasters;
